import { render, staticRenderFns } from "./ModalCopyProduct.vue?vue&type=template&id=e7969472&scoped=true&"
import script from "./ModalCopyProduct.vue?vue&type=script&lang=js&"
export * from "./ModalCopyProduct.vue?vue&type=script&lang=js&"
import style0 from "./ModalCopyProduct.vue?vue&type=style&index=0&id=e7969472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7969472",
  null
  
)

export default component.exports